import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { logoutUser } from '../../store/actions/Authentication';
import { browserHistory } from 'react-router';

import Icon from '../../components/Icon';
import SideBar from '../../components/SideBar';

function mapStateToProps(state) {
   return {
    isAuthenticated: state.authentication.isAuthenticated,
    user: state.user.data
  }
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => {
      dispatch(logoutUser())
    }
  }
}

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSidebar: false
    }
    this.goToLogin = this.goToLogin.bind(this);
    this.goToProfile = this.goToProfile.bind(this);
    this.revealSidebar = this.revealSidebar.bind(this)
    this.onResize = this.onResize.bind(this)
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize);
  }

  onResize() {
    if (this.state.showSidebar && window.innerWidth > 600) {
      this.setState({ showSidebar: false })
    }
  }

  goToLogin() {
    browserHistory.push('login');
  }

  goToProfile() {
    browserHistory.push('profile');
  }

  revealSidebar() {
    this.setState({ showSidebar: !this.state.showSidebar })
  }

  render() {
    const { siteName, isAuthenticated, logout } = this.props;
    const { showSidebar } = this.state;
    return (
      <div>
        <header className="center">
          <div className="content_wrapper">
            <div className="Header__left">
              <div className="Header__logo">
                <Link to="/">
                  <img src="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_handwritten_logo_4.png" alt="Moose Almighty" />

                </Link>
              </div>
            </div>
              <div className="Header__right Header__right--desktop">
  
                <div className="Header__links">
                  <a target="_blank" href="https://open.spotify.com/artist/24r28WlEze44ZfRyJCTykU?si=a5ifafujQSqmDrbAxivRYA&dl_branch=1">
                    Spotify
                  </a>
                  <Link to="/store">
                    Store
                  </Link>
                  <Link to="/presskit">
                    Press Kit
                  </Link>
                  <Link to="/contact">
                    Contact
                  </Link>
                </div>
     
              </div>

              <div className="Header__right Header__right--mobile">
                <span onClick={this.revealSidebar}>
                  <img src="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/icons/icon_hamburger.png" alt="Open sidebar menu" />
                </span>
              </div>

          </div>
          { showSidebar ?
            <SideBar 
              isAuthenticated={isAuthenticated} 
              logout={logout} 
              revealSidebar={this.revealSidebar} 
              goToProfile={this.goToProfile}
              goToLogin={this.goToLogin}
            />
            : null
          }
        </header>
        
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);




// WEBPACK FOOTER //
// ./src/containers/Header/Header.js